import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
export var LeaguePrizesStars = function (_a) {
    var stars = _a.stars;
    var renderedItems = [];
    for (var starIndex = 0; starIndex < 3; starIndex++) {
        if (starIndex < stars) {
            renderedItems.push(React.createElement(Icon, { icon: IdIcon.RatingStarFillIcn, styleId: IdStyles.IconSmall, key: starIndex }));
        }
        else {
            renderedItems.push(React.createElement(Icon, { icon: IdIcon.RatingStarEmptyIcon, styleId: IdStyles.IconSmall, key: starIndex }));
        }
    }
    return React.createElement("div", { className: "flex flex--guts" }, renderedItems);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/LeaguePrizesStars.tsx
// module id = 2794
// module chunks = 3